import { render, staticRenderFns } from "./DocumentEchocardiography.vue?vue&type=template&id=b5e7fe98&scoped=true"
import script from "./DocumentEchocardiography.vue?vue&type=script&lang=js"
export * from "./DocumentEchocardiography.vue?vue&type=script&lang=js"
import style0 from "./DocumentEchocardiography.vue?vue&type=style&index=0&id=b5e7fe98&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e7fe98",
  null
  
)

export default component.exports